import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import CreditRechargeButtonNode from "./Components/CreditRechargeButtonNode";
import { useSelector } from "react-redux";
import BuyCredits from "./Components/BuyCredits";

export default function CreditRechargePanel({ channel }) {
  const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
 
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [payingPackId, setPayingPackId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadPacks();
  }, [channel]);

  async function loadPacks() {

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(
        `${webUrlNode}/api/credits/packs?channel=${channel}&appToken=${appToken}&currentToken=${currentToken}`
      );

      const data = await res.json();
    console.log(data)
      setPacks(data?.length?data: []);

    } catch (e) {
      setError("Failed to load packs");
    }

    setLoading(false);
  }

  async function startRecharge(packId) {

    setPayingPackId(packId);

    try {

      const res = await fetch(
        `${webUrlNode}/api/credits/recharge/create`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ packId })
        }
      );

      const data = await res.json();

      if (!window.Razorpay) {
        alert("Razorpay SDK not loaded");
        return;
      }

      const options = {
        key: window.RAZORPAY_KEY_ID,   // inject once globally
        amount: data.amountPaise,
        currency: data.currency,
        order_id: data.orderId,
        handler: async function (response) {

          await verifyPayment(data.rechargeId, response);

        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (e) {
      console.error(e);
      alert("Failed to start payment");
    }

    setPayingPackId(null);
  }

  async function verifyPayment(rechargeId, rzpResponse) {

    await fetch(
      `${webUrlNode}/api/credits/recharge/verify`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          rechargeId,
          razorpayOrderId: rzpResponse.razorpay_order_id,
          razorpayPaymentId: rzpResponse.razorpay_payment_id,
          razorpaySignature: rzpResponse.razorpay_signature
        })
      }
    );

    alert("Credits added successfully");

    // you can refresh wallet after this
  }

  return (
    <>
      <BuyCredits
  channel={channel}
  packs={packs}
  loading={loading}
  error={error} />
       
    </>
  );
}
